import { useTranslation } from 'react-i18next';
import './speech.css';

export default function SpeechBubble({ backgroundColor, border, mascot, text, bubbleoutline, bubbleBackgroundColor }) {
  const { t } = useTranslation();

  return (
    <div
      className="speech__bubble"
      style={{ backgroundColor: backgroundColor || 'transparent', border: border || 'none' }}
    >
      <img src={mascot} alt={t('mascot.alt')} />
      <div className="bubble">
        <svg viewBox="0 0 194 42" preserveAspectRatio="none" className="bubble__svg">
          <path
            d="M189.19 40.6001H11.6009C9.71921 40.6001 8.19091 39.2786 8.19091 37.6515V35.0333C8.19091 33.3154 6.56708 31.936 4.58029 31.9608L2.22096 31.9939C0.864592 32.0104 0.100441 30.6476 0.969665 29.7391L6.20411 24.2631C7.49362 22.9168 8.19091 21.2319 8.19091 19.481V3.54869C8.19091 1.9216 9.71921 0.600098 11.6009 0.600098H189.19C191.072 0.600098 192.6 1.9216 192.6 3.54869V37.635C192.6 39.2621 191.072 40.5836 189.19 40.5836V40.6001Z"
            stroke={bubbleoutline || '#058794'}
            strokeWidth="1.2"
            fill={bubbleBackgroundColor || 'white'}
          />
        </svg>

        <p className="bubble__texts">{text}</p>
      </div>
    </div>
  );
}
